const DEFAULT_WHATSAPP_NUMBER = "+201090335442";

const toDigits = (value) => String(value || "").replace(/[^0-9]/g, "");

const normalizeInternational = (value) => {
  const digits = toDigits(value);
  if (!digits) return "";
  if (digits.startsWith("00")) return `+${digits.slice(2)}`;
  return `+${digits}`;
};

const formatInternational = (value) => {
  const digits = toDigits(value);
  if (digits.startsWith("20") && digits.length === 12) {
    return `+20 ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`;
  }
  return normalizeInternational(value);
};

const configuredWhatsapp = process.env.REACT_APP_WHATSAPP_NUMBER || DEFAULT_WHATSAPP_NUMBER;
const configuredPhone = process.env.REACT_APP_PHONE_NUMBER || configuredWhatsapp;

export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || "hello@hayat.clinic";
export const CONTACT_EMAIL_HREF = `mailto:${CONTACT_EMAIL}`;

export const CONTACT_PHONE_NUMBER = normalizeInternational(configuredPhone);
export const CONTACT_PHONE_DISPLAY = formatInternational(configuredPhone);
export const CONTACT_PHONE_HREF = `tel:${CONTACT_PHONE_NUMBER}`;

export const CONTACT_WHATSAPP_NUMBER = normalizeInternational(configuredWhatsapp);
export const CONTACT_WHATSAPP_DISPLAY = formatInternational(configuredWhatsapp);
export const CONTACT_WHATSAPP_DIGITS = toDigits(CONTACT_WHATSAPP_NUMBER);

export const getWhatsAppUrl = (message = "") => {
  const base = `https://wa.me/${CONTACT_WHATSAPP_DIGITS}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};
